<template>
  <v-container>
    <v-dialog v-model="openFlag" max-width="450px">
      <c-card class="white" title="비밀번호확인">
        <v-row>
          <v-text-field
            outlined
            :type="pwdShow ? 'text' : 'password'"
            v-model="password"
            placeholder="엑셀파일을 다운로드 하려면 개인 비밀번호를 입력하세요."
            @keyup.enter="checkMyPassword"
            :append-icon="pwdShow ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="pwdShow = !pwdShow"
          ></v-text-field>
        </v-row>
        <v-row justify="center">
          <c-btn class="mr-2" color="blue" outlined @click="checkMyPassword">확인</c-btn>
          <c-btn color="grey" outlined @click="openFlag = false">취소</c-btn>
        </v-row>
      </c-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    name: "DownloadExcelDialog",
    props: {
      open: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        openFlag: false,
        pwdShow: false,
        password: ""
      }
    },
    methods: {
      async checkMyPassword() {
        try {
          const res = await this.$api.checkMyPassword(this.password);
          if ( res && res.data && res.data.code == 0 ) {
            this.$emit('reqDownloadExcel');
          } else {
            if ( res && res.data && res.data.message ) {
              this.$store.commit('snackbar', {msg : res.data.message, where:'checkMyPassword'});
            } else {
              this.$store.commit('snackbar', {msg : '알 수 없는 오류가 발생하였습니다.', where:'checkMyPassword'});
            }
          }
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'checkMyPassword'});
        }
      }
    },
    watch: {
      open(newVal) {
        this.openFlag = newVal;
      },
      openFlag(newVal) {
        this.password = "";
        if(newVal === false) {
          this.$emit('update:open', false);
        }
      }
    },
  }
</script>

<style scoped>

</style>
